module.exports = __webpack_public_path__ + "img/09.6f61cb11.png";